export const MENU = {
    "આઇસ ડીસ": [
        { id: "id_01", name: "ગુલાબ કાલાખટ્ટા", nameEn: "Gulab Kalakhatta", price: 70 },
        { id: "id_02", name: "ગુલાબ ઑરેન્જ", nameEn: "Gulab Orange", price: 70 },
        { id: "id_03", name: "કાચી કેરી", nameEn: "Kachi Keri", price: 70 },
        { id: "id_04", name: "સ્ટ્રોબેરી", nameEn: "Strawberry", price: 70 },
        { id: "id_05", name: "બ્લુબેરી ", nameEn: "BlueBerry", price: 80 },
        { id: "id_06", name: "ચીકુ ડીસ", nameEn: "Chiku Dish", price: 90 },
        { id: "id_07", name: "ટોપરુ", nameEn: "Topru", price: 100 },
        { id: "id_08", name: "માવા ટોપરુ", nameEn: "Mawa Topru", price: 110 },
        { id: "id_09", name: "ચોકલેટ ચિપ્સ", nameEn: "Chocolate Chips", price: 120 },
        { id: "id_10", name: "ચોકલેટ મલાઈ", nameEn: "Chocolate Malai", price: 120 },
        { id: "id_11", name: "મીક્ષ ડીસ", nameEn: "Mix Dish", price: 130 },
        { id: "id_12", name: "બટરસ્કોચ", nameEn: "Butterscotch", price: 140 },
        { id: "id_13", name: "ઠંડાઈ", nameEn: "Thandai", price: 140 },
        { id: "id_14", name: "મેંગો કાજુ", nameEn: "Mango Kaju", price: 150 },
        { id: "id_15", name: "પંચામૃત", nameEn: "Panchamrut", price: 160 },
        { id: "id_16", name: "માવા કાજૂ", nameEn: "Mawa Kaju", price: 170 },
        { id: "id_17", name: "રજવાડી મલાઈ", nameEn: "Rajwadi Malai", price: 180 },
        { id: "id_18", name: "રાજભોગ મલાઈ", nameEn: "Rajbhog Malai", price: 190 },
        { id: "id_19", name: "રસ મલાઈ ", nameEn: "Ras Malai", price: 200 },
        { id: "id_20", name: "જે.બી. સ્પેશિયલ", nameEn: "J.B. Special", price: 210 },
    ],
    "આઈસ્ક્રીમ પ્યાલી": [
        { id: "ip_01", name: "ગુલાબ", nameEn: "Gulab", price: 60 },
        { id: "ip_02", name: "કાલાખટ્ટા", nameEn: "Kalakhatta", price: 60 },
        { id: "ip_03", name: "ઑરેન્જ", nameEn: "Orange", price: 70 },
        { id: "ip_04", name: "સ્ટ્રોબેરી", nameEn: "Strawberry", price: 70 },
        { id: "ip_05", name: "બ્લુબેરી ", nameEn: "BlueBerry", price: 70 },
        { id: "ip_06", name: "ચીકુ પ્યાલી", nameEn: "Chiku Pyali", price: 80 },
        { id: "ip_07", name: "ટોપરુ પ્યાલી", nameEn: "Topru Pyali", price: 90 },
        { id: "ip_08", name: "માવા ટોપરુ", nameEn: "Mawa Topru", price: 100 },
        { id: "ip_09", name: "મિક્સ પ્યાલી", nameEn: "Mix Pyali", price: 110 },
        { id: "ip_10", name: "ચોકલેટ ચિપ્સ", nameEn: "Chocolate Chips", price: 110 },
        { id: "ip_11", name: "ઠંડાઈ", nameEn: "Thandai", price: 130 },
        { id: "ip_12", name: "બટરસ્કોચ", nameEn: "Butterscotch", price: 130 },
        { id: "ip_13", name: "મેંગો કાજુ", nameEn: "Mango Kaju", price: 140 },
        { id: "ip_14", name: "માવા કાજુ", nameEn: "Mawa Kaju", price: 150 },
        { id: "ip_15", name: "રજવાડી મલાઈ", nameEn: "Rajwadi Malai", price: 160 },
        { id: "ip_16", name: "રાજભોગ મલાઈ", nameEn: "Rajbhog Malai", price: 170 },
        { id: "ip_17", name: "રસ મલાઈ ", nameEn: "Ras Malai", price: 180 },
        { id: "ip_18", name: "જે.બી. સ્પેશિયલ", nameEn: "J.B. Special", price: 190 },
    ],
    "સળી ગોલા": [
        { id: "sg_01", name: "ગુલાબ", nameEn: "Gulab", price: 30 },
        { id: "sg_02", name: "કાલાખટ્ટા", nameEn: "Kalakhatta", price: 30 },
        { id: "sg_03", name: "કાચી કેરી", nameEn: "Kachi Keri", price: 30 },
        { id: "sg_04", name: "ઑરેન્જ", nameEn: "Orange", price: 30 },
        { id: "sg_05", name: "સ્ટ્રોબેરી", nameEn: "Strawberry", price: 30 },
        { id: "sg_06", name: "બ્લુબેરી ", nameEn: "BlueBerry", price: 30 },
        { id: "sg_07", name: "ચીકુગોલા", nameEn: "Chiku Gola", price: 40 },
        { id: "sg_08", name: "ટોપરુ", nameEn: "Topru", price: 40 },
        { id: "sg_09", name: "માવા મલાઈ", nameEn: "Mawa Malai", price: 50 },
        { id: "sg_10", name: "મીક્ષ ગોળો ", nameEn: "Miksha Golo", price: 50 },
        { id: "sg_11", name: "ચોકલેટ", nameEn: "Chocolate", price: 50 },
        { id: "sg_12", name: "મલાઈ ટોપરુ", nameEn: "Malai Topru", price: 50 },
        { id: "sg_13", name: "મેંગો કાજુ", nameEn: "Mango Kaju", price: 50 },
        { id: "sg_14", name: "માવા કાજુ", nameEn: "Mawa Kaju", price: 50 },
        { id: "sg_15", name: "રજવાડી મલાઈ", nameEn: "Rajwadi Malai", price: 50 },
        { id: "sg_16", name: "રાજભોગ મલાઈ", nameEn: "Rajbhog Malai", price: 50 },
        { id: "sg_17", name: "બટરસ્કોચ", nameEn: "Butterscotch", price: 50 },
        { id: "sg_18", name: "ઠંડાઈ", nameEn: "Thandai", price: 50 },
        { id: "sg_19", name: "રસ મલાઈ ", nameEn: "Ras Malai", price: 50 },
        { id: "sg_20", name: "જે.બી. સ્પેશિયલ", nameEn: "J.B. Special", price: 60 },
    ],
};

export const CATEGORY_ICONS = {
    "આઇસ ડીસ": "🍧",
    "આઈસ્ક્રીમ પ્યાલી": "🍨",
    "સળી ગોલા": "🧊",
};